module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_step03-3d2cadb91acff91d9ae22e9379ee5e09.png";